/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { GenericApiResponseListCourseData } from './genericApiResponseListCourseData';
import type { GenericApiResponseListCourseMessage } from './genericApiResponseListCourseMessage';
import type { GenericApiResponseListCoursePagination } from './genericApiResponseListCoursePagination';
import type { GenericApiResponseListCourseError } from './genericApiResponseListCourseError';

export interface GenericApiResponseListCourse {
  data?: GenericApiResponseListCourseData;
  message?: GenericApiResponseListCourseMessage;
  pagination?: GenericApiResponseListCoursePagination;
  error?: GenericApiResponseListCourseError;
  statusCode?: number;
}
